"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolyphemosRebalanced = void 0;
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var PolyphemosRebalanced = (function (_super) {
    __extends(PolyphemosRebalanced, _super);
    function PolyphemosRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.POLYPHEMOS_REBALANCED,
            startingMegaCredits: 55,
            cardType: CardType_1.CardType.CORPORATION,
            cardCost: 5,
            metadata: {
                cardNumber: 'R11',
                description: 'You start with 55 M€. Increase your M€ production 5 steps. Gain 5 titanium.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(55).nbsp.production(function (pb) { return pb.megacredits(5); }).nbsp.titanium(5).digit;
                    b.corpBox('effect', function (ce) {
                        ce.effect('When you buy a card to hand, pay 5M€ instead of 3, including the starting hand.', function (eb) {
                            eb.cards(1).asterix().startEffect.megacredits(5);
                        });
                        ce.effect('When playing a card with a basic cost of 20MC or more, draw a card.', function (eb) {
                            eb.megacredits(20).asterix().startEffect.cards(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    PolyphemosRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 5);
        player.titanium = 5;
        return undefined;
    };
    PolyphemosRebalanced.prototype.onCardPlayed = function (player, card) {
        if (player.corporationCard !== undefined && player.corporationCard.name === this.name && card.cost >= 20) {
            player.drawCard();
        }
    };
    return PolyphemosRebalanced;
}(Card_1.Card));
exports.PolyphemosRebalanced = PolyphemosRebalanced;
//# sourceMappingURL=PolyphemosRebalanced.js.map